module.exports = __webpack_public_path__ + "img/no_hour.6ffae224.svg";